import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { getFilterRoundList } from 'modules/InterviewerDashboard/actions'
import { Wrapper } from 'modules/Roles/Partials/RolesFilter/Styles/style'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

const DriveRoleFilter = ({ setRoundFilter, roundFilter }) => {
  const params = useParams()
  const dispatch = new useDispatch()
  const [rolesList, setRolesList] = useState([])
  const UserData = useSelector(state => state?.auth?.userData)

  useEffect(() => {
    ;(async () => {
      const UserId = params?.userId ? params?.userId : UserData?._id

      let responce = await dispatch(getFilterRoundList(UserId))
      setRolesList(responce?.interviewRounds)
    })()
    return () => {}
  }, [])

  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={roundFilter}
        options={rolesList}
        onChange={value => setRoundFilter(value)}
        valueParam="id"
        labelParam="interviewround"
      />
    </Wrapper>
  )
}

export default DriveRoleFilter
